'use client';

import React from 'react';
import './ThreeBodyLoader.css';

const Loading = ({ size = 50, speed = 1, color = '#3b76fb' }) => {
  const style: React.CSSProperties = {
    width: `${size}px`,
    padding: `${size * 0.16}px`,
    background: color,
    animation: `l3 ${speed}s infinite linear`,
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center backdrop-blur-sm z-50"
      suppressHydrationWarning
    >
      <div 
        className="loader" 
        style={style}
        suppressHydrationWarning
      />
    </div>
  );
};

export default Loading;